import { useCallback, useState } from 'react';

type CookieHook = {
  getCookie: (name: string) => string | null;
  addCookie: (name: string, value: string) => void;
};

export const usePersistentCookie = (): CookieHook => {
  const [cookies, setCookies] = useState(() => {
    const allCookies = document.cookie.split('; ').reduce((acc, cookie) => {
      const [key, value] = cookie.split('=');
      acc[key] = value;
      return acc;
    }, {} as Record<string, string>);
    return allCookies;
  });

  const getCookie = useCallback(
    (name: string): string | null => cookies[name] || null,
    [cookies],
  );

  const addCookie = (name: string, value: string) => {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 100);

    const domain = window.location.hostname;

    document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/; domain=.${domain}; Secure; SameSite=None`;

    setCookies(prevCookies => ({
      ...prevCookies,
      [name]: value,
    }));
  };

  return { getCookie, addCookie };
};
